import { CSSProperties } from 'react';

import { useScreen } from './useScreen';

export function useSticky() {
  const { isMobile } = useScreen();
  const stickyStyle = { position: 'sticky', top: '24px', height: 'fit-content' } as CSSProperties;
  const stickyOnDesktopStyle = isMobile ? {} : stickyStyle;
  return { stickyOnDesktopStyle };
}
